import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },

  itemText: {
    fontSize: "1.4rem",
    lineHeight: "1.8rem",
    textTransform: "none",
  },
}));

const NavigationMenuHeading = props => {
  const { icon, primary, children, expand = false } = props;
  const [open, setOpen] = React.useState(expand);
  const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <li>
      <ListItem onClick={handleClick} button>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText
          classes={{ root: classes.itemText }}
          disableTypography={true}
          primary={primary}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List className={classes.nested} component="ul" disablePadding>
          {children}
        </List>
      </Collapse>
    </li>
  );
};

export default NavigationMenuHeading;
